import {
  ApiCobrandingSettings,
  apiCobrandingSettingsToCobrandingSettings,
} from '@types'

interface LoadAccountCobrandingSettingsCoordinator {
  RestService: {
    get: (url: string) => Promise<ApiCobrandingSettings | null>
  }
  HandleError: any
}
export const LoadAccountCobrandingSettings =
  ({ RestService, HandleError }: LoadAccountCobrandingSettingsCoordinator) =>
  async (accountId: string) => {
    try {
      const settings = await RestService.get(
        `/api/admin/accounts/${accountId}/branding`,
      )
      if (!settings) {
        return null
      }

      return apiCobrandingSettingsToCobrandingSettings(settings)
    } catch (error) {
      HandleError({ error })

      return null
    }
  }
